import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import ReCAPTCHA from 'react-google-recaptcha'

import api from 'services/pet-notify-api'
import Layout from 'components/Layout/SplitLayout'
import {
  Header,
  Text,
  Label,
  Input,
  Button,
  FieldGroup,
  Loader,
  Fields,
} from '@pet-notify/ui'
import { useHistory } from 'react-router'
import { RECAPTCHA_SITE_KEY } from 'config'

function ForgotPasswordScreen() {
  const history = useHistory()
  const { register, handleSubmit } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string>()
  const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null)
  const [isCaptchaSuccessful, setIsCaptchaSuccessful] = useState(false)

  const handleCaptcha = (token: string | null) => {
    setRecaptchaToken(token)
    setIsCaptchaSuccessful(!!token)
  }

  const onSubmit = handleSubmit(async ({ email }) => {
    setIsLoading(true)
    setError(undefined)

    // Validate reCAPTCHA before submitting
    if (!isCaptchaSuccessful || !recaptchaToken) {
      setError('Please complete the reCAPTCHA verification')
      setIsLoading(false)
      return
    }

    try {
      await api.users.forgotPassword({ email, recaptchaToken })
      history.push({
        pathname: '/forgot-password/check-email',
        state: { email },
      })
    } catch (error) {
      if (error instanceof Error) {
        setError(error.message)
      }
    } finally {
      setIsLoading(false)
    }
  })

  return (
    <Layout alternateBackground2>
      <Header as='h1' size='xxlarge' mb='8'>
        Forgot Password
      </Header>

      <form onSubmit={onSubmit} className='mb-8'>
        <Fields>
          <FieldGroup>
            <Label htmlFor='forgot-password-email'>Email</Label>
            <Input
              type='email'
              id='forgot-password-email'
              {...register('email')}
            />
          </FieldGroup>
          <Text>
            We will send you an email with instructions on how to reset your
            password.
          </Text>
          {error && <Text variant='error'>{error}</Text>}
          {RECAPTCHA_SITE_KEY && (
            <FieldGroup>
              <ReCAPTCHA
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={handleCaptcha}
              />
            </FieldGroup>
          )}
        </Fields>

        {isLoading ? <Loader /> : <Button type='submit'>Reset password</Button>}
      </form>
    </Layout>
  )
}
export default ForgotPasswordScreen
